import angular, {
  IAttributes,
  IController,
  IDirective,
  IScope,
  ITranscludeFunction,
} from "angular";
import { MachineDetailConfigurationViewController } from "./controller";
import { MachineConfiguration } from "../../../../../../models/machineConfiguration";
import { Machine } from "../../../../../../models/machine";

export const vsComponentName = "machineDetailConfigurations";
interface machineDetailConfigurationViewDirectiveScope extends IScope {
  addMachineConfigurationView: (
    index: number,
    machine: Machine<MachineConfiguration>,
    machineConfiguration: MachineConfiguration
  ) => void;
}
export function machineDetailConfigurationViewDirective(): IDirective {
  return {
    controller: MachineDetailConfigurationViewController,
    controllerAs: "configurationComponentController",
    template: require("!html-loader!./index.html").default,
    bindToController: {
      machine: "<",
      accordionHeading: "&?",
    },
    transclude: {
      configurationView: "configurationView",
    },
    link: {
      pre: (
        s: IScope,
        instanceElement: JQLite,
        instanceAttributes: IAttributes,
        controller?: IController,
        transclude?: ITranscludeFunction
      ) => {
        const scope = <machineDetailConfigurationViewDirectiveScope>s;
        scope.addMachineConfigurationView = (
          index: number,
          machine: Machine<MachineConfiguration>,
          machineConfiguration: MachineConfiguration
        ) => {
          if (!transclude || !transclude.isSlotFilled("configurationView"))
            return;

          const slot = angular.element(
            instanceElement.find("div.panel-body")[index]
          );
          transclude(
            (clonedElement?: JQLite, scope?: IScope) => {
              slot.children().remove();
              slot.append(clonedElement!);
              const s = <any>scope;
              s.machineConfiguration = machineConfiguration;
              s.machine = machine;
            },
            undefined,
            "configurationView"
          );
        };
      },
    },
  };
}

// export const machineDetailConfigurationViewComponentOptions: IComponentOptions =
//   {
//     controller: MachineDetailConfigurationViewController,
//     controllerAs: "configurationComponentController",
//     template: require("!html-loader!./index.html").default,
//     bindings: {
//       machine: "<",
//     },
//     transclude: true,
//   };
